import './Dashboard.css';

function Footer() {
  return null;
}

export default Footer;
